<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('wholesale.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('wholesale.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="true" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              style="width: 200px" @change="fetchData()" />
            <ts-button color="success" @click.prevent="onExport" :waiting="exporting" class="ml-2">
              <i class="fas fa-file-excel"></i> {{ $t('export') }}
            </ts-button>
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <div class="ts-border-gray-200 ts-border ts-rounded ts-p-2 ts-flex ts-items-center">
              <input v-model="searchAllDate" @change="fetchData()" type="checkbox" id="searchAllDate" />
              <label for="searchAllDate" class="ts-mb-0 ts-ml-1">{{
                $t('stockIn.searchAllDate')
              }}</label>
            </div>
            <ts-input v-tooltip="$t('wholesale.search')" v-model="search" :placeholder="$t('search')"
              style="width: 250px" class="inline-block" />
            <ts-filter ref="filter">
              <div class="row mb-3">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                    :filterOption="(input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                      " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')" @change="changeBranch()">
                  </a-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{
                    $t('wholesaleReceipt.warehourse')
                  }}</label>
                  <a-select style="width: 257px" v-model="location_id" :options="locations" showSearch mode="multiple"
                    :filterOption="(input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                      " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                  </a-select>
                </div>
              </div>
              <div class="row ts-mt-3">
                <div class="col-md-12">
                  <label class="">{{ $t('wholesaleReceipt.status') }}</label>
                  <a-select style="width: 257px" v-model="is_paid" :allowClear="true" :options="[
                    { value: 0, label: 'No' },
                    { value: 1, label: 'Yes' }
                  ]" :placeholder="$t('all')">
                  </a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'stock_out_date'
        }">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.location_name_en }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.invoice_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.reference_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer ? record.customer.customer_name : null }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.owner ? record.owner.customer_name : null }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{
                $currencyFormat(record.sub_total * record.fx_rate_thb, 'thb')
              }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{ $defaultCurrencyWithCode(record.sub_total) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-blue-700">
              <b>{{ $defaultCurrencyWithCode(record.discount, 4) }}</b>
            </td>
            <td class="ts-whitespace-no-wrap ts-text-blue-700">
              <b>{{ $defaultCurrencyWithCode(record.vat_amount, 4) }}</b>
            </td>
            <td class="ts-whitespace-no-wrap ts-text-blue-700">
              <b>{{ $defaultCurrencyWithCode(record.amount_paid, 4) }}</b>
            </td>
            <td class="ts-whitespace-no-wrap ts-text-blue-700">
              <b>{{ $defaultCurrencyWithCode(record.amount_due, 4) }}</b>
            </td>
            <td class="ts-whitespace-no-wrap text-center ts-text-blue-700">
              <b>{{
                $defaultCurrencyWithCode(record.receipt_amount_paid, 4)
              }}</b>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.next_payment_date }}
            </td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_paid">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.sale ? record.sale.employee_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.user.name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.remarks }}</td>
            <td class="text-left ts-space-x-3 ts-whitespace-no-wrap">
              <a href="#" v-tooltip="$t('wholesale.reprint')" class="text-primary"
                @click.prevent="reprintReport(record)">
                <i class="fas fa-print"></i>
              </a>
              <a href="#" v-tooltip="$t('view')" class="text-primary" @click.prevent="viewData(record)">
                <i class="fas fa-eye"></i>
              </a>
              <!-- v-if="!record.is_paid" -->

              <a href="#" :disabled="record._deleting" @click="onEdit(record)">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-edit" v-else></i>
              </a>
              <a href="#" v-if="record.ref_sfo_id" :disabled="record._deleting"
                @click="showDeleteInvoiceFromBorrowing(record)">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
              <a-popconfirm v-else placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
                :cancel-text="$t('no')" @confirm="deleteRecord(record)">
                <a href="#" :disabled="record._deleting">
                  <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
      <a-modal v-if="is_edit_invoice" v-model="is_edit_invoice" :title="$t('edit')" :footer="null"
        @cancel="onModalCancel">
        <EditMainSaleInvoice :editData="invoiceEdit" @cancel="onModalCancel" />
      </a-modal>
      <a-modal v-if="show_whole_sale" v-model="show_whole_sale" :title="$t('wholesale.pageTitle')" :zIndex="1020"
        :footer="null" :maskClosable="false" width="70%">
        <EditMainSaleInvoice :editData="invoiceEdit" @cancel="onModalCancel" />
      </a-modal>
      <a-modal v-if="show_whole_sale" v-model="show_whole_sale" :title="$t('wholesale.pageTitle')" :zIndex="1020"
        :footer="null" :maskClosable="false" width="70%">
        <ts-loading-banner :loading="show_whole_sale_waiting">
          <ViewWholeSale :record="items" />
        </ts-loading-banner>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce, trim } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './components/reason_delete'
import Currency from './components/currency.vue'
import ViewWholeSale from './components/view-whole-sale.vue'
import EditMainSaleInvoice from './components/edit-main-sale-invoice.vue'
import * as FileDownload from 'downloadjs'

export default {
  name: 'wholesaleIndex',
  components: {
    Reason,
    EditMainSaleInvoice,
    ViewWholeSale,
    EditMainSaleInvoice
  },
  data() {
    return {
      loading: false,
      show_pdf: false,
      exporting: false,
      is_edit_invoice: false,
      invoiceEdit: [],
      wholesalereceipt: false,
      receipt_data: {},
      waiting: false,
      show_whole_sale_waiting: false,
      show_whole_sale: false,
      src: null,
      currency: {
        value: 'USD'
      },
      model: {
        deleted_reason: null
      },
      errors: new Errors(),
      locations: [],
      items: [],
      branchs: []
    }
  },
  async created() {
    this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.getBranch()
    this.changeBranch()
    this.location_id = [
      this.$store.state.authUser.user.default_location.location_id
    ]
  },
  computed: {
    ...mapState('wholesale/operation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.operation.search
      },
      set(newValue) {
        this.$store.commit('wholesale/operation/SET_SEARCH', newValue)
        this.$store.commit('wholesale/operation/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.operation.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/operation/SET_DATE_RANGE', newValue)
      }
    },
    searchAllDate: {
      get() {
        return this.$store.state.wholesale.operation.searchAllDate
      },
      set(newValue) {
        this.$store.commit('wholesale/operation/SET_SEARCH_ALL_DATE', newValue)
      }
    },
    location_id: {
      get() {
        return this.$store.state.wholesale.operation.location_id
      },
      set(newValue) {
        this.$store.commit('wholesale/operation/SET_LOCATION_ID', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.wholesale.operation.branch_id
      },
      set(newValue) {
        this.$store.commit('wholesale/operation/SET_BRANCH_ID', newValue)
      }
    },
    is_paid: {
      get() {
        return this.$store.state.wholesale.operation.is_paid
      },
      set(newValue) {
        this.$store.commit('wholesale/operation/SET_IS_PAID', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('wholesale.branchName') },
        { name: this.$t('wholesale.warehouse') },
        { name: this.$t('wholesale.invoiceNo') },
        { name: this.$t('wholesale.referenceNo') },
        { name: this.$t('wholesale.customer') },
        { name: this.$t('wholesale.owner') },
        { name: this.$t('wholesale.subTotalThb') },
        { name: this.$t('wholesale.subTotal') },
        { name: this.$t('wholesale.discount') },
        { name: this.$t('wholesale.vatAmount') },
        { name: this.$t('wholesale.amountPaid') },
        { name: this.$t('wholesale.amountDue') },
        {
          name: this.$t('wholesale.receiptAmountPaid'),
          style: 'text-align:center;'
        },
        { name: this.$t('wholesale.nextPayment') },
        { name: this.$t('wholesale.isPaid') },
        { name: this.$t('wholesale.saleName') },
        { name: this.$t('wholesale.createdBy') },
        { name: this.$t('wholesale.remark') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'wholesale-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/operation/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    reprintReport(record) {
      this.$confirm({
        title: this.$t('which_currency_you_wish'),
        content: h =>
          h(Currency, {
            props: {
              value: this.currency
            }
          }),
        okText: this.$t('preview'),
        cancelText: this.$t('cancel'),
        centered: true,
        onOk: () => {
          this.show_pdf = true
          this.waiting = true
          return this.$store
            .dispatch('wholesale/operation/reprint', {
              id: record.stock_out_id,
              currency: this.currency.value
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.src = response.url
              return Promise.resolve(response)
            })
            .catch(error => {
              this.waiting = false
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
            .finally(() => {
              this.waiting = false
            })
        },
        onCancel() { }
      })
    },
    edit(record) {
      this.$store.commit('wholesale/operation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'wholesale-edit',
        params: { id: record.stock_out_id }
      })
    },
    viewData(record) {
      this.show_whole_sale = true
      this.show_whole_sale_waiting = true
      this.items = []
      this.$store
        .dispatch('wholesale/operation/viewItem', record.stock_out_id)
        .then(response => {
          this.items = response
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.show_whole_sale_waiting = false
        })
    },
    onEdit(record) {
      this.is_edit_invoice = true
      this.invoiceEdit = record
    },
    onModalCancel() {
      this.is_edit_invoice = false
      this.invoiceEdit = []
      this.fetchData()
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('wholesale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('wholesale/operation/destroy', {
              id: record.stock_out_id,
              data: this.model
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() { }
      })
    },
    showDeleteInvoiceFromBorrowing(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('to_delete_this_invoice_it_will_also_delete_all_invoices_from_the_same_borrowing_number'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          this.deleteRecord(record)
        }
      })
    },
    getBranch() {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async changeBranch() {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    viewData(record) {
      this.show_whole_sale = true
      this.show_whole_sale_waiting = true
      this.items = []
      this.$store
        .dispatch('wholesale/operation/viewItem', record.stock_out_id)
        .then(response => {
          this.items = response
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.show_whole_sale_waiting = false
        })
    },
    onExport(attributes) {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('wholesale/operation/exportExel', { ...attributes })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
          this.show_export_form = false
          this.clearInput()
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.exporting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    location_id: debounce(function () {
      this.fetchData(this.search)
    }, 500),
    is_paid: debounce(function () {
      this.fetchData(this.search)
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/operation/RESET_STATE')
    next()
  }
}
</script>
